import { formatPattern } from "react-router-utils";
import ArticleList from "app/components/ArticleList";
import Button from "app/components/UI/Button";
import CheckoutDetail from "./CheckoutDetail";
import CheckoutLayout from "app/components/CheckoutLayout";
import EmptyCart from "./EmptyCart";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import PreviousLink from "app/components/UI/PreviousLink";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "app/components/UI/Spinner";
import Title from "app/components/UI/Title";

export const CheckoutCart = ({
  clubId,
  isLoading,
  history,
  translate,
  onCheckoutClear,
  onCheckoutConfirm,
  sale,
  articles,
  onDeleteArticle
}) =>
  isLoading ? (
    <Spinner absolute />
  ) : articles.size ? (
    <CheckoutLayout
      header={
        <PreviousLink to={formatPattern("/:clubId/shop", { clubId: clubId })}>
          {translate("Revenir à la boutique")}
        </PreviousLink>
      }
      leftCol={
        <div>
          <Flex direction="row" middle>
            <Flex size={1}>
              <Title component="h2">{translate("Mon Panier")}</Title>
            </Flex>
            <Button.Flat
              onClick={onCheckoutClear}
              className="checkout__btn_empty_cart"
              label={translate("Vider mon panier")}
            />
          </Flex>

          <ArticleList clubId={clubId} isLoading={false} articles={articles} onDeleteArticle={onDeleteArticle} />
        </div>
      }
      rightCol={
        <div>
          <Title component="h2">{translate("Votre commande")}</Title>

          <CheckoutDetail
            clubId={clubId}
            sale={sale}
            articles={articles}
            onCheckoutConfirm={() => history.push(formatPattern("/:clubId/identification", { clubId: clubId }))}
          />
        </div>
      }
    />
  ) : (
    <EmptyCart clubId={clubId} />
  );

CheckoutCart.propTypes = {
  translate: PropTypes.func.isRequired,
  clubId: PropTypes.string.isRequired,
  sale: ImmutablePropTypes.map,
  articles: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default CheckoutCart;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutCart/CheckoutCart.js